export default __webpack_public_path__ + "static/media/5_hello ideate.35aa6916.jpg";